import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { LicenseSettingList } from '../license-mgt.model';

export enum LicenseSettingListActionTypes {
  GetLicenseSettingLists = '[LicenseSettingList] Get LicenseSettingLists',
  LoadLicenseSettingLists = '[LicenseSettingList] Load LicenseSettingLists',
  AddLicenseSettingList = '[LicenseSettingList] Add LicenseSettingList',
  UpsertLicenseSettingList = '[LicenseSettingList] Upsert LicenseSettingList',
  AddLicenseSettingLists = '[LicenseSettingList] Add LicenseSettingLists',
  UpsertLicenseSettingLists = '[LicenseSettingList] Upsert LicenseSettingLists',
  UpdateLicenseSettingList = '[LicenseSettingList] Update LicenseSettingList',
  UpdateLicenseSettingLists = '[LicenseSettingList] Update LicenseSettingLists',
  DeleteLicenseSettingList = '[LicenseSettingList] Delete LicenseSettingList',
  DeleteLicenseSettingLists = '[LicenseSettingList] Delete LicenseSettingLists',
  ClearLicenseSettingLists = '[LicenseSettingList] Clear LicenseSettingLists',
  GetLicenseSettingListsFails = '[LicenseSettingList] Get LicenseSettingLists'
}

export class GetLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.GetLicenseSettingLists;
  constructor(public payload: number) {}
}

export class LoadLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.LoadLicenseSettingLists;

  constructor(public payload: LicenseSettingList[]) {}
}

export class AddLicenseSettingList implements Action {
  readonly type = LicenseSettingListActionTypes.AddLicenseSettingList;

  constructor(public payload: { licenseSettingList: LicenseSettingList }) {}
}

export class UpsertLicenseSettingList implements Action {
  readonly type = LicenseSettingListActionTypes.UpsertLicenseSettingList;

  constructor(public payload: { licenseSettingList: LicenseSettingList }) {}
}

export class AddLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.AddLicenseSettingLists;

  constructor(public payload: { licenseSettingLists: LicenseSettingList[] }) {}
}

export class UpsertLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.UpsertLicenseSettingLists;

  constructor(public payload: { licenseSettingLists: LicenseSettingList[] }) {}
}

export class UpdateLicenseSettingList implements Action {
  readonly type = LicenseSettingListActionTypes.UpdateLicenseSettingList;

  constructor(public payload: { licenseSettingList: Update<LicenseSettingList> }) {}
}

export class UpdateLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.UpdateLicenseSettingLists;

  constructor(public payload: { licenseSettingLists: Update<LicenseSettingList>[] }) {}
}

export class DeleteLicenseSettingList implements Action {
  readonly type = LicenseSettingListActionTypes.DeleteLicenseSettingList;

  constructor(public payload: { id: string }) {}
}

export class DeleteLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.DeleteLicenseSettingLists;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearLicenseSettingLists implements Action {
  readonly type = LicenseSettingListActionTypes.ClearLicenseSettingLists;
}

export class GetLicenseSettingListsFails implements Action {
  readonly type = LicenseSettingListActionTypes.GetLicenseSettingListsFails;
}

export type LicenseSettingListActions =
  GetLicenseSettingLists
 | LoadLicenseSettingLists
 | AddLicenseSettingList
 | UpsertLicenseSettingList
 | AddLicenseSettingLists
 | UpsertLicenseSettingLists
 | UpdateLicenseSettingList
 | UpdateLicenseSettingLists
 | DeleteLicenseSettingList
 | DeleteLicenseSettingLists
 | ClearLicenseSettingLists
 | GetLicenseSettingListsFails;
